import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router.js'

Vue.config.productionTip = false

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// axios
import axios from 'axios'
Vue.prototype.$http = axios
Vue.prototype.CancelToken = axios.CancelToken;

// Session
import VueSession from 'vue-session'
var options = {
  persist: true
}
Vue.use(VueSession, options)

// vue-json-excel

import JsonExcel from 'vue-json-excel'
Vue.component("JsonExcel", JsonExcel);

// v-viewer

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

// Custom Loading Spinner Component

import LoadingSpinner from '@/components/LoadingSpinner.vue'
Vue.component("loading-spinner", LoadingSpinner);

// Custom Loading Spinner Component

import UploadProgress from '@/components/UploadProgress.vue'
Vue.component("upload-progress", UploadProgress);

// VueMaskDirective
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

import DefaultLayout from "@/layouts/DefaultLayout.vue";
Vue.component("default-layout", DefaultLayout);

import BlankLayout from "@/layouts/BlankLayout.vue";
Vue.component("blank-layout", BlankLayout);

import FooterContent from "@/components/FooterContent.vue";
Vue.component("footer-content", FooterContent);

import DemoMode from "@/DemoMode.vue";
Vue.component("demo-mode", DemoMode);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
